import ConfigCmsApi from "../configs/ConfigCmsApi";
import Cookies from "js-cookie";

const alias = "/offers/services";

const headers = () => ({ Authorization: Cookies.get("adminToken") });

const getServices = (params) =>
  ConfigCmsApi.get(alias, { params, headers: headers() });

const upsertService = (data) =>
  ConfigCmsApi.post(alias, data, { headers: headers() });

const deleteService = (id) =>
  ConfigCmsApi.delete(`${alias}/${id}`, { headers: headers() });

export default {
  getServices,
  upsertService,
  deleteService,
};
